// File: src/utils/speech.js

// Initialize speech synthesis
const synth = window.speechSynthesis;
let isAudioEnabled = false;

// Function to unlock audio (call this on the first user interaction)
export const enableAudio = () => {
    if (isAudioEnabled) return;
    
    // Play a silent utterance to unlock the audio context in the browser
    const utterance = new SpeechSynthesisUtterance('');
    synth.speak(utterance);
    isAudioEnabled = true;
    console.log("TTS Audio unlocked");
};

export const getIsAudioEnabled = () => isAudioEnabled;

export const speakAlert = (text) => {
    if (!synth) {
        console.warn("Speech Synthesis not supported in this browser.");
        return;
    }
    
    if (!isAudioEnabled) {
        console.warn("Audio not enabled yet. User must interact with the page first.");
        return;
    }

    // Cancel any ongoing speech so this alert is heard immediately
    synth.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    
    // Try to find an Indian English voice
    let voices = synth.getVoices();
    let indianVoice = voices.find(v => v.lang.includes('en-IN') || v.lang.includes('hi-IN'));
    
    if (indianVoice) {
        utterance.voice = indianVoice;
    }
    
    // Set properties for clear announcements
    utterance.volume = 1;      // Max volume
    utterance.rate = 0.9;      // Slightly slower for clarity
    utterance.pitch = 1;       // Normal pitch
    
    synth.speak(utterance);
};

// Handle cases where voices are loaded asynchronously
if (synth && synth.onvoiceschanged !== undefined) {
    synth.onvoiceschanged = () => {
        // Just trigger the load
        synth.getVoices();
    };
}
